import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'LpuPci'

const GetAllByPci = (pciId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/pci/${pciId}`, data, config)

export default {
  GetAllByPci
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/lpupci.js